import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './header/Header';
import Sidebar from './sidebar/Sidebar';

export default function AdminDashboard() {
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);

  const toggleSideBar = () => {
    setIsSideBarOpen(!isSideBarOpen);
  };

  return (
    <div className="min-h-screen text-white bg-gradient-to-br from-orange-400 via-white to-green-400">
      <div className="flex h-screen relative">
        {/* Sidebar */}
        <div
          className={`backdrop-blur-md bg-white/10 text-white fixed md:static z-50 h-full transition-all duration-300
            ${isSideBarOpen ? 'w-2/3' : 'w-0'} md:w-64 overflow-hidden shadow-lg border-r border-white/10`}
        >
          <Sidebar />
        </div>

        {/* Overlay */}
        {isSideBarOpen && (
          <div
            className="fixed inset-0 bg-black opacity-40 md:hidden z-40"
            onClick={toggleSideBar}
          />
        )}

        {/* Main Content */}
        <div
          className={`flex flex-col transition-all duration-300 
            ${isSideBarOpen ? 'w-1/3' : 'w-full'} md:flex-1`}
        >
          {/* Header */}
          <div className="backdrop-blur-md bg-white/10 border-b border-white/10 z-20">
            <Header toggleSideBar={toggleSideBar} />
          </div>

          {/* Page Content */}
          <main className="flex-1 overflow-y-auto p-4 md:p-6">
            <div className="rounded-xl shadow-md bg-white/5 backdrop-blur-md border border-white/10 p-4 md:p-6">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}